import Vue from "vue";
import Vuex from "vuex";
import { getToken, removeToken, setToken } from "../utils/auth";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    token: "",
    isToken: false,
  },
  mutations: {
    // 设置token状态
    loginSuccess(state, i) {
      state.isToken = i;
    },
    // 设置token
    setToken(state, token) {
      state.token = token;
    },
  },
  actions: {
    // 重置token
    resetToken({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    },
  },
  modules: {},
  getters: {
    token: (state) => state.token,
    getUser: (state) => state.user,
  },
});
